
import { formatDate, getDateProperty, formatDateNoHours } from "~/utils/common";

export default {
  head: {
    script: [
      {
        async: true,
        defer: true,
        crossorigin: "anonymous",
        src: "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v16.0",
        nonce: "cJMAH2j3",
      },
    ],
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    location: {
      type: String,
      default: "",
    },
    organizational_units: {
      type: String,
      default: "",
    },
    registion_start_time: {
      type: String,
      default: "",
    },
    registion_end_time: {
      type: String,
      default: "",
    },

    num_of_register: {
      type: Number,
      default: 0,
    },
    school_name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      visible: false,
      host: "",
    };
  },

  computed: {
    getDay() {
      return getDateProperty(this.registion_end_time, "day");
    },
    getMonth() {
      return getDateProperty(this.registion_end_time, "month");
    },
    startTimeFormat() {
      return formatDateNoHours(this.registion_start_time);
    },
    endTimeFormat() {
      return formatDate(this.registion_end_time);
    },
    isExpired() {
      const isExpired =
        new Date().getTime() > new Date(this.registion_end_time).getTime();
      return isExpired;
    },
  },
  mounted() {
    const fullUrl = this.$nuxt.context.req
      ? `${this.$nuxt.context.req.protocol}://${this.$nuxt.context.req.get(
        "host"
      )}${this.$nuxt.context.req.url}`
      : window.location.href;
    this.host = fullUrl;
  },

  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    share() {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.host
      )}`;
      window.open(
        shareUrl,
        "_blank",
        "toolbar=0,status=0,width=626,height=436"
      );
    },
  },
};
